import React from "react";
import { Link } from "react-router-dom";
import { Printer } from "lucide-react";
import { MarketingPage } from "@/components/Marketing";
import { useSeo } from "@/lib/useSeo";

const PET_FIELDS = ["Name / species / breed", "Food brand & exact amount", "Feeding times", "Medications (as prescribed by vet) & times", "Walks / litter / cage routine", "Allergies & conditions", "Quirks & fears", "Microchip #"];
const HOUSE = ["Owner phone", "Emergency contact nearby", "Vet name & phone", "24-hour emergency vet", "Where supplies are kept", "Wi-Fi / door codes"];
const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const Line = ({ label }) => (
  <div className="flex items-end gap-3 py-2 border-b border-dashed border-slate-300"><span className="text-sm font-semibold w-56 shrink-0">{label}</span><span className="flex-1" /></div>
);

export default function SitterChecklist() {
  useSeo("Free printable pet sitter checklist", "Free printable pet sitter checklist: food, meds, routines, vet and emergency info, plus a daily care log.");
  return (
    <MarketingPage>
      <div className="max-w-3xl mx-auto px-5 py-12">
        <div className="no-print mb-8">
          <h1 className="font-heading text-5xl font-extrabold">Free pet sitter checklist</h1>
          <p className="text-slate-600 mt-3">Print it (or save as PDF), fill it in, and leave it on the fridge. One page per pet.</p>
          <div className="flex flex-wrap gap-3 mt-5">
            <button onClick={() => window.print()} className="pl-btn-primary" data-testid="checklist-print-btn"><Printer className="h-4 w-4" />Print / save PDF</button>
            <Link to="/signup" className="pl-btn-ghost" data-testid="checklist-try-app-btn">Make it automatic with PackLog</Link>
          </div>
        </div>
        <section className="pl-card p-7 print-page" data-testid="checklist-sheet">
          <h2 className="font-heading text-3xl font-bold mb-4">Pet care sheet</h2>
          <h3 className="font-heading font-semibold text-lg mt-2">Pet</h3>
          {PET_FIELDS.map((f) => <Line key={f} label={f} />)}
          <h3 className="font-heading font-semibold text-lg mt-6">House & contacts</h3>
          {HOUSE.map((f) => <Line key={f} label={f} />)}
          <h3 className="font-heading font-semibold text-lg mt-6 mb-2">Daily care log</h3>
          <table className="w-full text-sm border border-slate-300">
            <thead><tr>{["", "AM food", "PM food", "Meds", "Walk / litter", "Initials"].map((h) => <th key={h} className="border border-slate-300 p-2 text-left">{h}</th>)}</tr></thead>
            <tbody>{DAYS.map((d) => <tr key={d}><td className="border border-slate-300 p-2 font-semibold">{d}</td>{[0, 1, 2, 3, 4].map((i) => <td key={i} className="border border-slate-300 p-2 h-9" />)}</tr>)}</tbody>
          </table>
          <p className="text-xs text-slate-500 mt-4">For any health concern, call the vet listed above. Made with PackLog: one shared log for every pet.</p>
        </section>
      </div>
    </MarketingPage>
  );
}
